module.exports = __webpack_public_path__ + "img/sysxf-select.b314553d.png";